module.exports = __webpack_public_path__ + "static/aappointPhone-5b709cf0051e16e0f8762eb046c6aabb.png";